module.exports = __webpack_public_path__ + "static/media/intro_2.c21584ab.png";